<template>
  <v-alert
    color="grey darken-4"
    dark
    dense
    v-model="showAlert"
    class="cookieMessage"
    :class="{ mobileLayout: isMobile }"
  >
    <v-row no-gutters align="center">
      <v-col :cols="isMobile ? 12 : undefined" class="grow text-left mt-2 mr-1">
        We use Cookies because let's face it, we're an advertising company - Cookies are what we do.
        By clicking Accept, you agree to the use of all Cookies.
      </v-col>
      <v-col :class="isMobile ? 'text-center' : 'shrink'">
        <v-btn @click="closeAlert" color="grey lighten-1">Accept</v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  data() {
    return {
      showAlert: false,
      cookieAccepted: false,
    }
  },
  mounted() {
    this.cookieAccepted = JSON.parse(localStorage.getItem('adacadoCookieAccepted')) || false
    if (!this.cookieAccepted) this.showAlert = true
  },
  methods: {
    closeAlert() {
      this.cookieAccepted = true
      localStorage.setItem('adacadoCookieAccepted', JSON.stringify(this.cookieAccepted))
      this.showAlert = false
    },
  },
  computed: {
    isMobile() {
      return window.innerWidth < 1000
    },
  },
}
</script>

<style lang="scss" scoped>
.cookieMessage {
  position: fixed;
  bottom: 0;
  width: 40%;
  left: 30%;
  border-radius: 0 !important;
  margin-bottom: 0;
  z-index: 10;
  &.mobileLayout {
    width: 100%;
    left: 0;
    bottom: unset;
  }
}
</style>
